export const LocationTypes = ['Locality', 'Country', 'State', 'City', 'Neighbourhood', 'County'] as const;

export type LocationType = (typeof LocationTypes)[number];

export function isLocationType(value: string): value is LocationType {
  return LocationTypes.includes(value as LocationType);
}

export interface GeoPoint {
  lat: number;
  lon: number;
}

export interface Coords {
  latitude: number;
  longitude: number;
}

export interface BaseAddress {
  locality?: string;
  coords?: Coords;
}

export interface AddressDetails {
  addressCode: string;
  addressId: number;

  fullAddress: string;

  streetAddress: string;
  suburbLine: string;

  suburb?: string;
  state: string;
  postcode?: string;

  regions: RegionDetails[];

  coords?: Coords;

  addressUrl: string;
  isAddressHidden: boolean;
}

export interface RegionDetails {
  locationId: number;
  locationType: LocationType;
  name: string;

  locationUrl?: string;
  locationPropertiesUrl?: string;
}

export interface NewAddressDetails extends BaseAddress {
  unitNumber?: string;
  streetNumber?: string;
  street?: string;
  localityId?: number;
  state?: string;
  postcode?: string;
  country?: string;
}

export type SelectionShapeType = 'Envelope' | 'PolygonOuterShell';

export interface SelectionShape {
  shapeType: SelectionShapeType;
  shapeCoordinates: GeoPoint[];
}

export interface LocationFilter {
  localityIds?: number | number[];
  neighbourhoodIds?: number | number[];
  cityIds?: number | number[];
  countyIds?: number | number[];
  stateIds?: number | number[];
}

export const getLocationFilters = (locationType: LocationType, locationIds: number | number[]): Partial<LocationFilter> | undefined => {
  const locationId = Array.isArray(locationIds) ? locationIds : [locationIds];

  switch (locationType) {
    case 'City':
      return { cityIds: locationId };
    case 'County':
      return { countyIds: locationId };
    case 'Locality':
      return { localityIds: locationId };
    case 'Neighbourhood':
      return { neighbourhoodIds: locationId };
    case 'State':
      return { stateIds: locationId };
    default:
      return undefined;
  }
};
